import {Pipe, PipeTransform} from '@angular/core';
import {Status} from '../enum/status';

@Pipe({
  name: 'status',
})
export class StatusPipe implements PipeTransform {

  transform(value: Status | undefined): string {
    switch (value) {
      case Status.ACTIVE:
        return 'Actief';
      case Status.INACTIVE:
        return 'Uit dienst';
      case Status.LEAVE:
        return 'Verlof';
      default:
        return value || 'onbekend';
    }
  }
}
